import { AnyAction } from 'redux';

import {
    DEMAND_CONTACT_TOPIC_REGION_COUNT_RECEIVED,
    DEMAND_DETAIL_TOPICS_RECEIVED,
    DEMAND_DETAIL_TOPICS_SUBMIT,
} from './demand-detail-topics-actions';
import { DEMAND_DETAIL_RESET } from '../demand-detail-actions';
import { Demand } from '../../../../models/demand';
import { DemandContactTopicRegionCount } from '../../../../models/demand-contact-topic-region-count';
import { StepData } from '../../../../../../common/components/new-stepper/step-data';
import { TopicsFormValues } from '../../models/topics-form-values';

export interface DemandDetailTopicsReducerState {
    contactCountPerTopicAndRegion: DemandContactTopicRegionCount[];
    stepData: StepData<TopicsFormValues>;
    /**
     * The step as the server last handed it over (#2159). `stepData.values`
     * cannot serve: leaving a wizard step parks its input right there.
     */
    baseline?: TopicsFormValues;
}

export const initialDemandDetailTopicsReducerState: DemandDetailTopicsReducerState = {
    contactCountPerTopicAndRegion: [],
    stepData: {
        errors: {},
        values: { topics: [], regions: [] },
        isValid: false,
        isDirty: false,
    },
};

export const demandDetailTopicsReducer = (
    state: DemandDetailTopicsReducerState = initialDemandDetailTopicsReducerState,
    action: AnyAction
): DemandDetailTopicsReducerState => {
    const { type } = action;

    switch (type) {
        case DEMAND_DETAIL_TOPICS_SUBMIT: {
            const data = action['data'] as StepData<TopicsFormValues>;
            return {
                ...state,
                stepData: {
                    ...state.stepData,
                    ...data,
                },
            };
        }

        case DEMAND_DETAIL_TOPICS_RECEIVED: {
            const demand = action['demand'] as Demand;
            const values = {
                topics: demand.topics ?? [],
                regions: demand.regions ?? [],
            };

            return {
                ...state,
                stepData: {
                    ...state.stepData,
                    isValid: true,
                    values,
                },
                // The same values, kept apart from the ones the wizard edits.
                baseline: values,
            };
        }

        case DEMAND_DETAIL_RESET: {
            return initialDemandDetailTopicsReducerState;
        }

        case DEMAND_CONTACT_TOPIC_REGION_COUNT_RECEIVED: {
            return {
                ...state,
                contactCountPerTopicAndRegion: action[
                    'contactCountPerTopicAndRegion'
                ] as DemandContactTopicRegionCount[],
            };
        }

        default: {
            return state;
        }
    }
};
